<template>
    <div v-if="route.isNumbersHistory">
        <div class="d-flex">
            <ul class="nav nav-pills px-2 py-2 mx-auto" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active tab-buttons" id="daily-tab" data-toggle="tab" href="#daily" role="tab" aria-controls="daily" aria-selected="true">Daily</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link tab-buttons" id="weekly-tab" data-toggle="tab" href="#weekly" role="tab" aria-controls="weekly" aria-selected="false">Weekly</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link tab-buttons" id="monthly-tab" data-toggle="tab" href="#monthly" role="tab" aria-controls="monthly" aria-selected="false">Monthly</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link tab-buttons" id="yearly-tab" data-toggle="tab" href="#yearly" role="tab" aria-controls="yearly" aria-selected="false">Yearly</a>
                </li>
            </ul>
        </div>
        <div class="py-0 px-0 code-box-border bg-light w-100 d-flex">
            <button class="btn btn-secondary w-100" @click="refreshNumbersdata()">REFRESH</button>
        </div>
    </div>
    <div v-else-if="route.isTries">
        <div class="d-flex" v-if="!pinFound">
            <input type="text" class="form-control m-1 text-center" name="" id="" aria-describedby="helpId" placeholder="Enter the PIN received in SMS">
        </div>
        <div class="py-0 px-0 code-box-border bg-light w-100 d-flex" v-if="pinFound">
            <!-- <router-link :to="{ name: 'getlucky'}" class="w-100">
                <button class="btn btn-success w-100" @click="refreshNumbersdata()">GET LUCKY</button>
            </router-link> -->
            <!-- <router-link :to="{ name: 'numbers_history', params:{id: 417}}" class="w-100">
                <button class="btn btn-light w-100" @click="refreshNumbersdata()">HISTORY</button>
            </router-link> -->
            <a :href="$router.resolve({ name: 'getlucky', params:{id: 417}}).href" class="w-75">
                <button class="btn btn-success w-100" @click="refreshNumbersdata()">GET LUCKY</button>
            </a>
            <a :href="$router.resolve({ name: 'numbers_history', params:{id: 417}}).href" class="w-25">
                <button class="btn btn-secondary w-100" @click="refreshNumbersdata()">HISTORY</button>
            </a>
        </div>
        <div class="py-1 px-1 code-box-border bg-success w-100 d-flex" v-else>
            <button class="btn btn-success w-100" @click="refreshNumbersdata()">CONFIRM PIN</button>
        </div>
    </div>
    <div v-else-if="route.isGetLucky">
        <div class="d-flex" v-if="!pinFound">
            <input type="text" class="form-control m-1 text-center" name="" id="" aria-describedby="helpId" placeholder="Enter the PIN received in SMS">
        </div>
        <div class="py-0 px-0 code-box-border bg-light w-100 d-flex" v-if="pinFound">
            <button class="btn btn-success w-100" @click="refreshNumbersdata()">GET LUCKY</button>

            <a :href="$router.resolve({ name: 'numbers_history', params:{id: 417}}).href" class="w-25">
                <button class="btn btn-secondary w-100" @click="refreshNumbersdata()">HISTORY</button>
            </a>
        </div>
        <div class="py-1 px-1 code-box-border bg-success w-100 d-flex" v-else>
            <button class="btn btn-success w-100" @click="refreshNumbersdata()">CONFIRM PIN</button>
        </div>
    </div>
    <div v-else-if="route.isSubscribe">
        <div class="d-flex" v-if="!msisdnFound">
            <input type="text" class="form-control m-1 text-center" name="msisdn" id="msisdn" aria-describedby="helpId" placeholder="Enter your phone number">
        </div>
        <div class="d-flex" v-else-if="!pinFound">
            <input type="text" class="form-control m-1 text-center" name="pin" id="pin" aria-describedby="helpId" placeholder="Enter the PIN received in SMS">
        </div>
        
        <div class="py-0 px-0 code-box-border bg-light w-100 d-flex" v-if="!msisdnFound">
            <button class="btn btn-success w-100" @click="subscribe()">SUBSCRIBE</button>
        </div>
        <div class="py-0 px-0 code-box-border bg-light w-100 d-flex" v-else-if="!pinFound">
            <button class="btn btn-success w-100" @click="validatePin()">CONFIRM</button>
        </div>
        <div class="py-1 px-1 code-box-border bg-success w-100 d-flex" v-else>
            <a :href="$router.resolve({ name: 'numbers_history', params:{id: this.$route.params.id}}).href" class="w-100">
                <button class="btn btn-success w-100">VIEW HISTORY</button>
            </a>
        </div>
    </div>
    <div v-else>
        <p>This is the DEFAULT section</p>
    </div>
</template>
<script type="text/babel">
  import { mapState } from 'vuex'

  export default {
        data() {
            return {
                route: {
                  isTries: false,
                  isNumbersHistory: false,
                  isGetLucky: false,
                  isSubscribe: false
                },
                pinFound: false,
                msisdnFound: false
            }
        },
        computed: mapState(['numbers']),
        methods: {
            refreshNumbersdata: function() {
                var id = this.$route.params.id;
                this.$store.dispatch('getNumbers', {type: 'daily', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
                this.$store.dispatch('getNumbers', {type: 'weekly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
                this.$store.dispatch('getNumbers', {type: 'monthly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
                this.$store.dispatch('getNumbers', {type: 'yearly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            },
            subscribe: function() {
                var msisdn = document.getElementById('msisdn').value
                console.log(msisdn)
                this.msisdnFound = true
                document.getElementById('msisdn').value = ''
            },
            validatePin: function() {
                var pin = document.getElementById('pin').value
                console.log(pin)
                //this.msisdnFound = false
                this.pinFound = true
            }
        },
        mounted: function () {
            //console.dir(this.$route.name);
            //this.refreshNumbersdata();
            switch (this.$route.name) {
                case 'tries':
                    this.route.isTries = true
                    this.route.isNumbersHistory = false
                    this.route.isGetLucky = false
                    //console.log('This is the TRIES route')
                    break;

                case 'numbers_history':
                    this.route.isTries = false
                    this.route.isNumbersHistory = true
                    this.route.isGetLucky = false
                    //console.log('This is the NUMBERS HISTORY route')
                    break;

                case 'getlucky':
                    this.route.isTries = false
                    this.route.isNumbersHistory = false
                    this.route.isGetLucky = true
                    //console.log('This is the GET LUCKY route')
                    break;
                    break;

                case 'subscribe':
                    this.route.isTries = false
                    this.route.isNumbersHistory = false
                    this.route.isGetLucky = false
                    this.route.isSubscribe = true
                    //console.log('This is the GET LUCKY route')
                    break;
            
                default:
                    break;
            }
        },
        components: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/footer.vue